import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import Theme from '../../../Theme/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

// The gutter that should appear between the handle and the outer container's border
var GUTTER = 2;
var BORDER_RADIUS = 15;

// Calculate the Dimensions of the Handle (The circle that moves)
var calculateHandleWidthHeight = function calculateHandleWidthHeight(containerHeight, gutterSize) {
  return containerHeight - gutterSize * 2;
};

// Calculate the lateral position (translateX) of the handle
// The handle is always GUTTER px away from the edge (+GUTTER px from the left, -GUTTER px from the right)
var calculateTranslateX = function calculateTranslateX(_ref) {
  var checked = _ref.checked,
    containerWidth = _ref.containerWidth,
    containerHeight = _ref.containerHeight,
    gutterSize = _ref.gutterSize;
  var translate = checked ? containerWidth - calculateHandleWidthHeight(containerHeight, gutterSize) - gutterSize : gutterSize;
  return "translateX(".concat(translate, "px)");
};

// The Wrapper for the text that appears on the left side of the toggle
// during the 'Active' state
var StyledLeft = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  position: relative;\n  pointer-events: none;\n  padding-left: 14%;\n  transition: opacity 0.25s ease 0s;\n  opacity: 0;\n"])), Theme.colors.lightBlue);

// The Wrapper for the text that appears on the right side of the toggle
// during the 'Not Active' state
var StyledRight = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  padding-right: 14%;\n  pointer-events: none;\n  transition: opacity 0.25s ease 0s;\n  opacity: 0;\n"])), Theme.colors.greyBlue);

// Then handle is pushed down, GUTTER pixels from the top of the container
// The container is always GUTTER * 2 pixels taller than the handle, which creates the
// GUTTER pixels space above and below the handle
var StyledHandle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: #fff;\n  display: inline-block;\n  cursor: pointer;\n  border-radius: 50%;\n  position: absolute;\n  top: ", "px;\n  outline: 0px;\n  border: 0px;\n  transition: background-color 0.25s ease 0s, transform 0.25s ease 0s;\n"])), GUTTER);
var StyledBG = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0px;\n  position: relative;\n  border-radius: ", "px;\n  cursor: pointer;\n  transition: background-color 0.25s ease 0s;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fff;\n"])), BORDER_RADIUS);
var ToggleWrapper = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  text-align: left;\n  border-radius: ", "px;\n  border: 1px solid ", ";\n  touch-action: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  user-select: none;\n  margin: 0;\n\n  ", " {\n    height: ", "px;\n    width: ", "px;\n  }\n\n  ", " {\n    background-color: ", ";\n    height: ", "px;\n    width: ", "px;\n    transform: ", ";\n  }\n\n  ", " {\n    font-weight: 600;\n    font-size: ", "px;\n    opacity: ", ";\n  }\n\n  ", " {\n    font-weight: 600;\n    font-size: ", "px;\n    opacity: ", ";\n  }\n\n  input {\n    border: 0px;\n    clip: rect(0px, 0px, 0px, 0px);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0px;\n    position: absolute;\n    width: 1px;\n  }\n"])), BORDER_RADIUS, Theme.colors.greyBlue, StyledBG, function (_ref2) {
  var containerHeight = _ref2.containerHeight;
  return containerHeight;
}, function (_ref3) {
  var containerWidth = _ref3.containerWidth;
  return containerWidth;
}, StyledHandle, function (_ref4) {
  var checked = _ref4.checked;
  return checked ? Theme.colors.lightBlue : Theme.colors.greyBlue;
}, function (_ref5) {
  var containerHeight = _ref5.containerHeight;
  return calculateHandleWidthHeight(containerHeight, GUTTER);
}, function (_ref6) {
  var containerHeight = _ref6.containerHeight;
  return calculateHandleWidthHeight(containerHeight, GUTTER);
}, function (_ref7) {
  var checked = _ref7.checked,
    containerWidth = _ref7.containerWidth,
    containerHeight = _ref7.containerHeight;
  return calculateTranslateX({
    checked: checked,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    gutterSize: GUTTER
  });
}, StyledLeft, function (_ref8) {
  var containerHeight = _ref8.containerHeight;
  return containerHeight * 0.4;
}, function (_ref9) {
  var checked = _ref9.checked;
  return checked ? 1 : 0;
}, StyledRight, function (_ref0) {
  var containerHeight = _ref0.containerHeight;
  return containerHeight * 0.4;
}, function (_ref1) {
  var checked = _ref1.checked;
  return checked ? 0 : 1;
});

export { StyledBG, StyledHandle, StyledLeft, StyledRight, ToggleWrapper, calculateHandleWidthHeight, calculateTranslateX };
